// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.2f635e24f',
  revision: '2f635e24f',
  branch: 'develop',
  date: 'Mon, 21 Sep 2026 15:57:24 GMT'
};